"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

/**
 * Global scroll restoration component
 * Ensures pages start at the top when navigating between routes
 */
export const SLScrollRestoration = () => {
  const pathname = usePathname();

  useEffect(() => {
    // Scroll to top on route change, unless there's a hash
    if (!window.location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname]);

  // This component doesn't render anything
  return null;
};
